import { defineMessage } from 'services/localization';

export const messages = {
    createAndConnect: defineMessage('create_and_connect'),
    createDemo: defineMessage('create_and_connect_a_bdemob_organisation'),
    demoHeader: defineMessage('perfect_for_thorough_te_ro_data_is_not_affected'),
    demoDescribe: defineMessage('check_how_approvalmax_f_rk_using_xero_demo_data'),
    xeroName: defineMessage('xero'),
    connectToOrganisation: defineMessage('connect_your_xero_organisation'),
    connectToOrgHeader: defineMessage('perfect_for_a_quick_start_on_live_xero_data'),
    buttonConnectToOrg: defineMessage('connect_to_xero'),
};
